import React, { useState, useEffect } from "react";
import Stack from "@mui/material/Stack";
import { Typography, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import placeHolder from "../../../assets/images/placeHolder.png";
import unavailable from "../../../assets/images/price_unavailable.png";
import quantity from "../../../assets/images/min_not_met.png";
import { functions } from "../../../utils";

const useStyles = makeStyles(() => ({
  customStack: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  iconStack: {
    position: "absolute",
    top: "8px",
    right: "8px",
    display: "flex",
    flexDirection: "row",
    gap: "8px",
  },
}));

function getErrorImage(
  index,
  setImageErrorCount,
  imageErrorCount,
  styleName,
  props,
  errorImage,
  e
) {
  const { images } = props;
  const currentSrc = e.target.src;

  // ---- helpers ----
  const findImage = (src) => images.find((img) => img === src) || null;

  const replaceVariant = (src, variant) =>
    src ? src.replace(/-[A-Za-z]/g, `-${variant}`) : null;

  const getFallbackFromIndex = () => {
    const defaultImage = images[index];
    const dashIndex = defaultImage.indexOf("-");
    if (dashIndex === -1) return null;

    const letter = defaultImage.substring(dashIndex + 1, dashIndex + 2);
    return currentSrc.replace("-O", `-${letter}`);
  };

  const buildCatalogUrl = (img) => {
    const cleanStyle = styleName.replace("/", "-");
    const parts = (img || images[index]).split("/");
    const fileName = parts[parts.length - 1];

    const [_, ...rest] = fileName.split("_");
    return `https://api2.hooverandstrong.com/catalog_images/${cleanStyle}_${rest.join(
      "_"
    )}`;
  };

  // ---- stop condition ----
  if (imageErrorCount >= 3) {
    e.target.src = placeHolder;
    setImageErrorCount(0);
    return;
  }

  // ---- find or derive image ----
  let newImage = findImage(currentSrc);

  if (!newImage) {
    const fallback = getFallbackFromIndex();
    newImage = findImage(fallback);
    newImage = newImage ? replaceVariant(newImage, "O") : null;
  }

  // ---- fallback to catalog API ----
  if (imageErrorCount === 2 || !newImage) {
    e.target.src = buildCatalogUrl(newImage) || errorImage;
    setImageErrorCount(imageErrorCount + 1);
    return;
  }

  // ---- variant switching logic ----
  if (/-[BTVFQ]/.test(newImage)) {
    const variant = imageErrorCount === 0 ? "O" : "C";
    e.target.src = replaceVariant(newImage, variant) || errorImage;
    return;
  }

  if (newImage.includes("-O")) {
    e.target.src = newImage.replace("-O", "-C") || errorImage;
    setImageErrorCount(imageErrorCount + 1);
    return;
  }

  if (newImage.includes("-C")) {
    e.target.src = newImage.replace("-C", "-O") || errorImage;
    setImageErrorCount(imageErrorCount + 1);
    return;
  }

  // ---- final fallback ----
  e.target.src = placeHolder;
}

export default function ProductGalleryViewer(props) {
  const [selectedImage, setSelectedImage] = useState(placeHolder);
  const [images, setImages] = useState([]);
  let styleName = props.styleName ?? "";
  const classes = useStyles();
  const errorImage =
    props.errorType === "product"
      ? unavailable
      : props.errorType === "generalError"
      ? placeHolder
      : quantity;

  useEffect(() => {
    setImages(props.images);
    props.baring
      ? setSelectedImage(props.images[1])
      : setSelectedImage(props.images[0]);
  }, [props.images, props.baring]);
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      border={"1px solid #e0e0e0"}
      position="relative"
    >
      {props.icons && (
        <Box className={classes.iconStack}>
          {props.icons.map((icon, key) => {
            const iconElement = functions.getIcons(icon);
            return iconElement ? (
              <Typography key={key} className="icons">
                {iconElement}
              </Typography>
            ) : null;
          })}
        </Box>
      )}

      <img
        src={props.error ? errorImage : selectedImage}
        onError={(e) => {
          if (props.isCoreStyle) {
            getErrorImage(
              0,
              props.setImageErrorCount,
              props.imageErrorCount,
              styleName,
              props,
              errorImage,
              e
            );
          } else {
            e.target.src = placeHolder;
          }
        }}
        onLoad={(e) => {
          if (
            props.isCoreStyle &&
            e.target.src.includes("XLG") &&
            !e.target.src.includes("_T_XLG") &&
            !e.target.src.includes("_P_XLG")
          ) {
            props.setCurrentMainImage(e.target.src);
          }
        }}
        alt="Selected Product"
        className="selected-product"
      />
      <Stack className={classes.customStack}>
        {!props.error &&
          images?.length > 1 &&
          images.map((image, index) => (
            <img
              key={index}
              src={image}
              style={{
                padding:
                  props.isCoreStyle && index > 0 ? "8px 0px 8px 0px" : "0px",
              }}
              className="detail-imgs"
              alt="Mini Product"
              onError={(e) => {
                if (props.isCoreStyle) {
                  var numImages = props.images.length;

                  if (image == props.images[0]) {
                    getErrorImage(
                      0,
                      props.setMiniImage1ErrorCount,
                      props.miniImage1ErrorCount,
                      styleName,
                      props,
                      errorImage,
                      e
                    );
                  } else if (numImages > 1 && image == props.images[1]) {
                    getErrorImage(
                      1,
                      props.setMiniImage2ErrorCount,
                      props.miniImage2ErrorCount,
                      styleName,
                      props,
                      errorImage,
                      e
                    );
                  } else {
                    e.target.src = placeHolder;
                  }
                } else {
                  if (e.target.src.includes("_P_")) {
                    e.target.src =
                      e.target.src.replace("_P_", "_W_") || placeHolder;
                  } else if (e.target.src.includes("_G_")) {
                    e.target.src =
                      e.target.src.replace("_G_", "_W_") || placeHolder;
                  } else if (e.target.src.includes("_Y_")) {
                    e.target.src =
                      e.target.src.replace("_Y_", "_W_") || placeHolder;
                  } else {
                    e.target.src = placeHolder;
                  }
                }
              }}
              onClick={() => {
                if (props.isCoreStyle) {
                  props.setMiniImage1ErrorCount(0);
                  props.setMiniImage2ErrorCount(0);
                  props.setImageErrorCount(0);
                }
                setSelectedImage(image);
              }}
            />
          ))}
      </Stack>
    </Stack>
  );
}
